import SModal from './src/main.vue';

export { SModal };

export default {
  install(Vue, options) {
    Vue.prototype.$smodal = opts => {
      const Modal = Vue.extend(SModal);
      const instance = new Modal({
        el: document.createElement('div'),
      });
      opts = Object.assign({}, opts, options);
      for (let key in opts) {
        instance[key] = opts[key];
      }
      instance.mode = 'cmd';
      document.body.appendChild(instance.$el);
      instance.open();
      return instance;
    };
  },
};
